export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/woocommerce.9a68dcf.svg";